/**
 * Design Tokens
 * Single source of truth for all design values.
 * Admin panel maps brand colors to these tokens.
 */

export const colors = {
  red:      '#D60B0B',
  redDark:  '#A30808',
  blue:     '#1718BF',
  blueDark: '#0f1099',
  gray:     '#6E767E',
  grayLight:'#9CA3AB',

  bg:       '#FAFBFC',
  bgDark:   '#060618',
  bgCard:   '#FFFFFF',

  text:      '#1A1A2E',
  textLight: '#555566',
  border:    '#E8EAED',
};

export const fonts = {
  body:    "'Outfit', sans-serif",
  display: "'Sora', sans-serif",
};

export const radius = {
  sm: '10px',
  md: '14px',
  lg: '20px',
  xl: '28px',
  full: '9999px',
};

export const shadow = {
  sm: '0 4px 24px rgba(0,0,0,0.06)',
  lg: '0 12px 48px rgba(0,0,0,0.10)',
};

export const transition = {
  default: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  fast:    'all 0.15s ease',
  slow:    'all 0.6s ease',
};
